import * as React from 'react';
import { isColorLight } from '../../js/colors';
import customStyle from './style.scss';
import { CSSProperties } from 'react';
import { ButtonBase } from '../button-base';

export interface Props {
  id?: string;
  iconSize?: number;
  style?: React.CSSProperties;
  iconStyle?: React.CSSProperties;
  iconColor?: string;
  onClick?: (e: React.MouseEvent) => void;
  onTouchStart?: (e: React.TouchEvent) => void;
  offsetY?: number;
  extraClickableZone?: number;
}

export interface CustomCssProperties extends CSSProperties {
  '--close-btn-background-color': string;
}

/**
 * Use `CloseButton` to display a close button
 */
export function CloseButton({
  iconSize = 30,
  id = 'close-control',
  iconColor = '#FFFFFF',
  onClick,
  onTouchStart,
  iconStyle = {},
  style = {},
  offsetY = 0,
  extraClickableZone = 0
}: Props) {
  const controlStyles: React.CSSProperties = {
    marginTop: offsetY,
    position: 'relative'
  };

  let clickableZone: React.CSSProperties = {};

  if (extraClickableZone > 0) {
    clickableZone = {
      ...clickableZone,
      position: 'absolute',
      left: '-' + extraClickableZone + 'px',
      right: '-' + extraClickableZone + 'px',
      bottom: '-' + extraClickableZone + 'px',
      top: '-' + extraClickableZone + 'px'
    };
  }

  return (
    <ButtonBase
      id="close-btn"
      data-zone="close_button"
      aria-label="ogury_close_button"
      onTouchStart={onTouchStart}
      onClick={onClick}
      style={controlStyles}
    >
      <div style={clickableZone}></div>
      <div
        style={
          {
            height: iconSize,
            width: iconSize,
            '--close-btn-background-color': isColorLight(iconColor)
              ? '#000'
              : '#FFF',
            ...style
          } as CustomCssProperties
        }
        className={customStyle.closeBtnBackgroundColor}
      >
        <svg
          id={id}
          width={iconSize}
          height={iconSize}
          fill={iconColor}
          x="0"
          y="0"
          viewBox="0 0 51.98 51.98"
          space="preserve"
          enableBackground="new 0 0 51.976 51.976"
          style={iconStyle}
        >
          <path d="M44.37 7.6c-10.14-10.14-26.63-10.14-36.77 0 -10.14 10.14-10.14 26.63 0 36.77s26.63 10.14 36.77 0C54.51 34.24 54.51 17.74 44.37 7.6zM36.24 36.24c-0.78 0.78-2.05 0.78-2.83 0l-7.42-7.42 -7.78 7.78c-0.78 0.78-2.05 0.78-2.83 0 -0.78-0.78-0.78-2.05 0-2.83l7.78-7.78 -7.42-7.42c-0.78-0.78-0.78-2.05 0-2.83 0.78-0.78 2.05-0.78 2.83 0l7.43 7.43 7.07-7.07c0.78-0.78 2.05-0.78 2.83 0 0.78 0.78 0.78 2.05 0 2.83l-7.07 7.07 7.43 7.43C37.02 34.19 37.02 35.46 36.24 36.24z" />
        </svg>
      </div>
    </ButtonBase>
  );
}
